import createLogger from 'nuxt-logger-module/dist/client.js'

const options = {"level":"info","factory":"nuxt-logger-module/dist/client.js"}
delete options.factory

createLogger(options)
